<template>
  <div class="member-area-tab-login-config-component">
    <div class="d-flex flex-column gap-4">
      <div class="mb-1">
        <h5 class="fs-14 text-semibold">Identificação da marca</h5>
        <small class="text-dark-40 fs-12">
          Por padrão, utilizamos o nome da sua Área de Membros.
        </small>
      </div>
      <div class="row mb-5">
        <snow-input-file
          v-model="form.brand"
          id="brand-image"
          isImage
          backgroundColor="bg-1"
          title="Logo"
          class="col-lg-4"
          dimensions="600x128"
        />
        <div class="col-lg-6 d-lg-flex d-none">
          <img src="@/assets/images/member-area/tab-login-brand.svg" />
        </div>
        <!-- <brand-mockup :image="form.brand" class="col-lg-6" /> -->
      </div>
      <div class="mb-1">
        <h5 class="text-semibold fs-14">Apresentação</h5>
        <small class="text-dark-40">
          Utilize fotos que se encaixem no contexto ou crie uma imagem
          costumizada.
        </small>
      </div>
      <div class="row">
        <snow-input-file
          isImage
          id="background-image"
          v-model="form.background"
          title="Imagem"
          backgroundColor="bg-1"
          class="col-lg-4"
          dimensions="1280x1224"
        />
        <div class="col-lg-6 d-lg-flex d-none">
          <img src="@/assets/images/member-area/tab-login-background.svg" />
        </div>
        <!-- <background-mockup :image="form.background" class="col-lg-6" /> -->
      </div>
    </div>

    <!-- <div class="d-lg-none d-flex flex-column gap-4">
      <div class="mb-1">
        <h5 class="fs-14">Identificação da marca</h5>
        <small class="text-dark-40">
          Por padrão, utilizamos o nome da sua Área de Membros.
        </small>
      </div>
      <snow-input-file
        id="brand-logo"
        v-model="form.brand"
        title="Logo"
        class="mb-5"
        dimensions="600x128px"
        backgroundColor="bg-1"
      />
      <div class="mb-1">
        <h5 class="text-semibold fs-14">Apresentação</h5>
        <small class="text-dark-40">
          Utilize fotos que se encaixem no contexto ou crie uma imagem
          costumizada.
        </small>
      </div>
      <snow-input-file
        id="bg-presentation"
        v-model="form.background"
        title="Imagem"
        dimensions="1280x1224px"
        backgroundColor="bg-1"
      />
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
